export class LogOptions {
    function: string | null = null;
    body: string | null = null;
    subject: string ='';
    withStackTrace: boolean = false;
}